import { IFeature } from '.';
import { EntityName } from '..';

export interface Ref extends IFeature {
    shareLink: string;
    allowEntities: EntityName[];
}
